
export function CentralPlaceholder({ text }: {text: string}) {
  return (
    <div className="h-[100px] flex flex-col items-center justify-center">
        
        <div className="enemy-turn">
            {text}
        </div>

    </div>
  );
}
